/* Header: estado scrolled, menú móvil (focus trap + Esc), búsqueda móvil, badge del carrito. */
(() => {
  const header = document.querySelector('[data-header]');
  if (!header) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Tras 24 px de scroll el header sube 8 px (translate en CSS) y queda visible en 48 px; las escenas fijas usan top: 3rem.
  // Un centinela a 24 px con IntersectionObserver reemplaza al listener de scroll.
  if (!reduce) {
    const centinela = document.createElement('div');
    centinela.setAttribute('aria-hidden', 'true');
    centinela.style.cssText = 'position:absolute;top:24px;left:0;width:1px;height:1px;pointer-events:none';
    document.body.prepend(centinela);
    new IntersectionObserver(([e]) => header.toggleAttribute('data-scrolled', !e.isIntersecting)).observe(centinela);
  }

  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])';
  function makeToggle(btn, panel, { lockScroll = false, focusFirst = false } = {}) {
    if (!btn || !panel) return () => {};
    let opener = null;
    let cierre = null;
    const setOpen = (open) => {
      clearTimeout(cierre);
      // Al cerrar, data-cerrando deja correr la salida (150 ms) antes de ocultar.
      if (open) { panel.removeAttribute('data-cerrando'); panel.hidden = false; }
      else if (!panel.hidden) {
        if (reduce) panel.hidden = true;
        else { panel.setAttribute('data-cerrando', ''); cierre = setTimeout(() => { panel.hidden = true; panel.removeAttribute('data-cerrando'); }, 150); }
      }
      btn.setAttribute('aria-expanded', String(open));
      btn.setAttribute('aria-label', btn.dataset[open ? 'labelClose' : 'labelOpen']);
      if (lockScroll) document.body.classList.toggle('overflow-hidden', open);
      if (open) {
        opener = document.activeElement;
        if (focusFirst) setTimeout(() => panel.querySelector(FOCUSABLE)?.focus(), 60);
        else panel.querySelector('input[type="search"]')?.focus();
      } else if (opener) { opener.focus(); opener = null; }
    };
    const abierto = () => btn.getAttribute('aria-expanded') === 'true';
    btn.addEventListener('click', () => setOpen(!abierto()));
    // Esc global: el foco puede seguir en el botón (aún no entró al panel).
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && abierto()) setOpen(false);
    });
    // Con el menú abierto, Tab recorre el botón (cerrar) y los enlaces del panel.
    const trap = (e) => {
      if (e.key !== 'Tab' || !lockScroll || !abierto()) return;
      const f = [btn, ...panel.querySelectorAll(FOCUSABLE)];
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    panel.addEventListener('keydown', trap);
    btn.addEventListener('keydown', trap);
    panel.addEventListener('click', (e) => { if (e.target.closest('a')) setOpen(false); });
    return setOpen;
  }
  const closeMenu = makeToggle(header.querySelector('[data-menu-toggle]'), header.querySelector('[data-mobile-menu]'), { lockScroll: true, focusFirst: true });
  const closeSearch = makeToggle(header.querySelector('[data-search-toggle]'), header.querySelector('#mobile-search'));
  matchMedia('(min-width: 768px)').addEventListener('change', (e) => { if (e.matches) { closeMenu(false); closeSearch(false); } });

  const badge = header.querySelector('[data-cart-count]');
  const cartBtn = header.querySelector('[data-cart-open]');
  addEventListener('cart:updated', (e) => {
    const n = e.detail?.item_count ?? 0;
    badge.textContent = n; badge.hidden = n === 0;
    // El aria-label del botón tapa el badge: el número va en el nombre accesible.
    const L = cartBtn.dataset;
    cartBtn.setAttribute('aria-label', n === 0 ? L.lEmpty : n === 1 ? L.lOne : L.lOther.replace('__N__', n));
  });
  cartBtn?.addEventListener('click', () => dispatchEvent(new CustomEvent('cart:open')));
})();
